export type DisclosureReviewJurisdiction = {
    jurisdiction?: string;
    reviewPending?: boolean;
    disclosurePending?: boolean;
    international?: boolean;
};

/**
 * Picks the jurisdiction admins should review when opening Review Disclosure
 * (e.g. from three-dot menu where no activity row country is available).
 */
export const resolveReviewDisclosureTargetJurisdiction = (
    disclosureReviews: DisclosureReviewJurisdiction[],
    fallback = "usPuerto",
): string => {
    if (!disclosureReviews?.length) {
        return fallback;
    }
    const pending = disclosureReviews.find(dr => dr.reviewPending || dr.disclosurePending);
    if (pending?.jurisdiction) {
        return pending.jurisdiction;
    }
    const international = disclosureReviews.find(dr => dr.international);
    if (international?.jurisdiction) {
        return international.jurisdiction;
    }
    return disclosureReviews[0]?.jurisdiction ?? fallback;
};

/**
 * Resolves which jurisdiction row to show in the modal when the preferred target
 * is missing or wrong (e.g. hardcoded usPuerto for international personnel).
 */
export const pickDisclosureReviewJurisdictionFromData = (
    data: DisclosureReviewJurisdiction[],
    preferred?: string,
): string | undefined => {
    if (!data?.length) {
        return preferred;
    }
    if (preferred && data.some(item => item.jurisdiction === preferred)) {
        return preferred;
    }
    return resolveReviewDisclosureTargetJurisdiction(data, data[0]?.jurisdiction);
};
